<template>
  <div class="container-fluid p-5" style=" margin-top: 50px; margin-bottom: 80px">
    <div class="d-flex flex-row justify-content-between">
      <h2 class="text-bg">Usuarios</h2>
    </div>
    <div class="d-flex justify-content-between pb-1 gap-2 w-25" style="border: 2px solid black; border-radius: 5px 5px 0 0; padding: 5px; background: black">
      <n-input placeholder="Buscar usuarios" v-model:value="searchBar" @keyup.enter="this.getUsers(this.searchBar)">
        <template #suffix>
          <i class="icon-remove-circle input-icon" @click="this.cleanSearch"></i>
        </template>
      </n-input>
      <n-button secondary type="info" @click="this.getUsers(this.searchBar)" style="background: white">Buscar</n-button>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-head-dark">
          <tr>
            <th scope="col" class="text-sm" @click="this.sortColumn('name')">
              Nombre
              <i v-if="this.selectedColumn === 'name'"
                :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm" @click="this.sortColumn('email')">
              Correo Electrónico
              <i v-if="this.selectedColumn === 'email'"
                :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm">Cambiar...</th>
            <th scope="col" class="text-sm">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr scope="row"  v-if="this.loading" style="width: 50vw; height: 2rem;">
              <td colspan="7">
                  <div class="d-flex justify-content-center" >
                      <div class="spinner-border" role="status">
                          <span class="sr-only"></span>
                      </div>
                  </div>
              </td>
          </tr>
          <tr scope="row"  v-else-if="!this.loading && this.users.length === 0" style="width: 50vw; height: 2rem;">
              <td colspan="7" class="text-center">
                  <n-p>No se encontraron resultados...</n-p>
              </td>
          </tr>
          <tr v-else-if="!this.loading && this.users.length > 0" v-for="(user, index) in usersNotAdmin" :key="index">

            <td scope="row" class="align-middle text-sm">{{user.name}}</td>
            <td scope="row" class="align-middle text-sm">{{user.email}}</td>
            <td scope="row" class="align-middle text-sm">
              <n-space>
                <n-button @click="emailModal(user)" type="info">
                  E-mail
                </n-button>
                <n-button @click="passwordModal(user)" type="info">
                  Password
                </n-button>
              </n-space>
            </td>
            <td scope="row" class="align-middle">
              <n-space>
                <n-button type="info" @click="loginAsUser({userId: user._id})">
                  Login
                </n-button>
                <n-button secondary type="info" @click="handleConfirm(user)">
                  Delete
                </n-button>
              </n-space>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-around pb-1 g-2 mt-2">
        <n-button type="info" size="medium" style="font-size: 20px" @click="this.goToPreviousPage"
          v-show="this.page > 1">
          &lt; Pagina anterior
        </n-button>
        <span type="info" size="medium" style="font-size: 20px" v-show="this.page - 1 === 0">
        </span>
        <n-p>Página {{this.page}} de {{this.numberOfPages}}</n-p>
        <n-button type="info" quaternary size="medium" style="font-size: 20px" @click="this.goToNextPage"
          :disabled="this.users.length < 25">
          Pagina siguiente &gt;
        </n-button>
      </div>
    </div>
    <!-- update e-mail modal -->
    <n-modal v-model:show="showEmailModal">
      <n-card style="width: 600px" title="Cambiar e-mail" :bordered="false" size="huge" role="dialog" aria-modal="true">
        <n-space vertical>
          <h6>
            <span class="updatePropertyText">E-mail actual:</span>
            <span class="updatePropertyValue">{{currentUser.email}}</span>
            <br />
            <span class="updatePropertyText">Nuevo e-mail:</span>
            <span class="updatePropertyValue">{{newEmail}}</span>
          </h6>
          <h6></h6>
          <n-input v-model:value="newEmail" type="text" placeholder="Ingrese un nuevo e-mail" />
          <div class="d-flex justify-content-center">
            <n-button type="info" @click="updateEmail()">
              ACTUALIZAR DATOS
            </n-button>
          </div>
        </n-space>
      </n-card>
    </n-modal>

    <n-modal v-model:show="showPasswordModal">
      <n-card style="width: 600px" title="Cambiar password:" :bordered="false" size="medium" role="dialog"
        aria-modal="true">
        <n-space vertical>
          <n-input v-model:value="newPassword" :type="showPassword ? 'text' : 'password'"
            placeholder="Ingrese una nueva contraseña">
            <template #suffix>
              <i v-if="!showPassword" class="icon-eye-close auth-icon" @click="toggleShowPassword"></i>
              <i v-else class="icon-eye-open auth-icon" @click="toggleShowPassword"></i>
            </template>
          </n-input>
          <div class="d-flex justify-content-center">
            <n-button type="info" @click="updatePassword()">
              ACTUALIZAR DATOS
            </n-button>
          </div>
        </n-space>
      </n-card>
    </n-modal>
  </div>
  <!-- update password modal -->
</template>

<script>

import { mapActions, mapState } from 'pinia';
import { useMessage, useLoadingBar, useDialog } from 'naive-ui';
import useUsers from '../../store/user'
import authStore from '../../store/auth';

export default {
  name: "DashboardAdmin",
  data(){
    return {
      message: useMessage(),
      dialog: useDialog(),
      loadingBar: useLoadingBar(),
      showEmailModal: false,
      showPasswordModal: false,
      currentUser: '',
      newEmail: '',
      newPassword: '',
      showPassword: false,
      selectedColumn: '',
      searchBar: ''
    }
  },
  methods: {
    ...mapActions(useUsers, ['getAllUsers', 'updateUserAsAdmin', 'updatePasswordAsAdmin', 'removeUser', 'sortUsers', 'searchUsers', 'getUsers', 'goToNextPage', 'goToPreviousPage']),
    ...mapActions(authStore, ['impersonateUser']),
    cleanSearch(){
      this.searchBar = "";
      this.getUsers();
    },
    sortColumn(key){
      this.sortUsers(key);
      this.selectedColumn = key;
    },
    handleConfirm(user) {
      this.dialog.warning({
        title: "Confirmar",
        // Check if icon is better hidden since it can't be centered to title of dialog
        // showIcon: false,
        content: "Esta seguro que desea eliminar al usuario?",
        positiveText: "ACEPTAR",
        negativeText: "CANCELAR",
        onPositiveClick: () => {
          this.deleteUser(user._id)
        },
        onNegativeClick: () => {
          this.message.error("Acción cancelada");
        }
      });
    },
    async deleteUser(userId){
      try{
        await this.removeUser(userId);
        this.message.success("Usuario eliminado!")
        await this.getAllUsers();
        location.reload()
      } catch(err){
        console.log(err);
        this.message.error(err.response.data.message);
      }
    },
    async loginAsUser(userId){
      try{
        this.loadingBar.start();
        await this.impersonateUser(userId);
        this.loadingBar.finish();
        this.message.success("Has impersonado a un usuario exitosamente!")
        this.$router.push('/app/plans/list');
      }catch(err){
        this.loadingBar.error();
        console.log(err);
        this.message.error(err.response.data.message);
      }
    },
    emailModal(user){
      this.showEmailModal = true,
      this.currentUser = user
    },
    passwordModal(user){
      this.showPasswordModal = true,
      this.currentUser = user
    },
    async updateEmail(){
      let regex = new RegExp('[A-Za-z0-9]+@[A-Za-z0-9]+\.[A-Za-z]{2,3}');
      if (!this.newEmail) {
        this.message.error("Por favor ingrese un correo electrónico")
        return;
      }
      if (!regex.test(this.newEmail)){
        this.message.error("Por favor ingrese una correo electrónico válido");
        return;
      }
      this.loadingBar.start();
      try {
        this.currentUser.email = this.newEmail.toLowerCase()
        await this.updateUserAsAdmin(this.currentUser._id, this.currentUser)
        this.message.success("Correo electrónico actualizado");
        this.showEmailModal = false
        this.newEmail = ''
        this.loadingBar.finish()
      } catch (err) {
        this.loadingBar.error();
        console.error(err)
        this.message.error(err.response.data.message);
      };
    },
    async updatePassword() {
      if (!this.newPassword) {
        this.message.error("Por favor ingrese una contraseña")
        return;
      }
      if (this.newPassword.length < 8){
        this.message.error("La contraseña debe tener al menos 8 caracteres");
        return;
      }

      if (this.newPassword === this.newPassword.toLowerCase()){
        this.message.error("La contraseña debe tener al menos 1 caracter en mayúscula");
        return;
      }
      if (!/\d/.test(this.newPassword)){
        this.message.error("La contraseña debe tener al menos 1 número");
        return;
      }
      this.loadingBar.start();
      try {
        await this.updatePasswordAsAdmin(this.currentUser._id.toString(), { password: this.newPassword })
        this.message.success("Contraseña actualizada");
        this.showPasswordModal = false
        this.newPassword = ''
        this.loadingBar.finish()
      }
      catch (err) {
        this.loadingBar.error();
        console.error(err)
        this.message.error(err.response.data.message);
      };
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword
    }
  },

  computed: {
    ...mapState(authStore, ['isLoggedIn', 'isAdmin']),
    ...mapState(useUsers, ['users', 'sortDirection', 'page', 'numberOfPages', 'loading']),
    usersNotAdmin(){
      return this.users.filter(user => user.email!="admin@admin.com")
    }
  },

  async mounted(){
    if(!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push('/app/login');

    } else {
      if (!this.isAdmin){
      this.message.info("No posees el rol necesario para acceder a esta ruta", { duration: 5000 });
        this.$router.push('/app/dashboard/user');
      }
    }

    await this.getUsers(this.searchBar)
  }
}
</script>

<style>



.n-result {
  margin: 10vh 0;
}

.list-border {
  border-bottom: 1px solid #000
}

.row-collapse-color1 {
  background-color: rgb(235, 235, 235);
}

.row-collapse-color2 {
  background-color: #fff;
}

.table-head-dark {
  background-color: rgb(0, 0, 0);
  color: rgb(255, 255, 255);
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
}

.table-border {
  border: solid black 2px;
}

.overflow{
  text-overflow: ellipsis;
}

.updatePropertyText{
  text-decoration: underline;
}

.updatePropertyValue{
  font-weight: 200;
  margin-left: 5px;
}

</style>